<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part-no" id="part01"><span class="t-bold">PART I</span></h2>
<h2 class="part-title"><span class="s-bold">Leadership Is Important Because It Affects All of Us</span></h2>
<p class="p-para">“Leadership is not about a title or a designation. It’s about impact, influence, and inspiration.”</p>
<p class="p-author">~ Robin S. Sharma</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?da2fd332